import React from 'react';

export interface Period { id: string | null; label: string; }

interface Props { periods: Period[]; current: Period; onChange: (p: Period) => void; }

export function PeriodSelector({ periods, current, onChange }: Props) {
  return (
    <select
      data-testid="h2h-period-selector"
      value={current.id ?? ''}
      onChange={(e) => {
        const selected = periods.find((p) => (p.id ?? '') === e.target.value);
        if (selected) onChange(selected);
      }}
      style={{ background: '#222', color: '#fff', padding: 10, border: 'none', borderRadius: 8, margin: 16 }}
    >
      {periods.map((p) => (
        <option key={p.id ?? 'all'} value={p.id ?? ''}>{p.label}</option>
      ))}
    </select>
  );
}
